export const mockConsumption = [
  6.95027397260274,
  6.94454794520548,
  6.947452054794521,
  6.929972602739726,
  7.083123287671233,
  7.935479452054794,
  12.12372602739726,
  26.037890410958905,
  28.504054794520545,
  28.215972602739726,
  27.080794520547943,
  24.74312328767123,
  25.314849315068493,
  24.775616438356167,
  22.563232876712327,
  13.356465753424656,
  9.791972602739726,
  9.187890410958904,
  8.727972602739726,
  8.157616438356165,
  7.663205479452055,
  7.395068493150684,
  7.027753424657535,
];
export const mockProduction = [
  0.0,
  0.0,
  0.0,
  0.0,
  0.002817605726027397,
  1.3050456065753424,
  4.896887494931507,
  11.317306721136985,
  20.739768169863012,
  28.43969117808219,
  33.29513205479452,
  35.421836986301365,
  35.38856301369863,
  33.285158082191785,
  27.696545342465754,
  20.194230912328766,
  11.669029997123289,
  5.17604510739726,
  1.2284022210410959,
  0.0010925074246575341,
  0.0,
  0.0,
  0.0,
  0.0,
];
